import React from 'react';

const Header = ({ cartCount, onCartClick }) => (
    <header className="bg-gradient-to-r from-orange-500 to-red-500 text-white p-4 shadow-lg rounded-b-lg">
        <div className="container mx-auto flex justify-between items-center">
            <h1 className="text-2xl font-bold">The Hungry Fork</h1>
            <button
                onClick={onCartClick}
                className="bg-white text-orange-500 px-4 py-2 rounded-full font-semibold hover:bg-gray-100 transition duration-300 shadow-md flex items-center"
            >
                🛒 (<span>{cartCount}</span>)
            </button>
        </div>
    </header>
);

export default Header;